import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpClient, HttpResponse } from '@angular/common/http';

import { Observable, merge } from 'rxjs';
import { map, switchMap, tap, catchError, every } from 'rxjs/operators';

import { environment } from '../../environments/environment';

@Component({
  selector: 'app-reservations',
  templateUrl: './reservations.component.html',
  styleUrls: ['./reservations.component.scss']
})
export class ReservationsComponent implements OnInit {

  search(confirmationNumber: string) {
    this.router.navigate(['santaCruz', 'reservations', confirmationNumber]);
  }

  @ViewChild('confirmationNumber',  { static: true }) confirmNumberElement: ElementRef;
  constructor(private route: ActivatedRoute, private http: HttpClient, private router: Router, ) { }

  viewDefaultPricingZones() {

  }

  viewState$: Observable<any>;

  ngOnInit() {

    this.confirmNumberElement.nativeElement.focus();

    const initial = this.route.params.pipe(map(v => ({
      data: {},

      isLoading: true,
      isLoaded: false,
      isError: false,
      errorMessage: ''
    })));

    const loader = this.http.get(`${environment.scApiProtocol}://${environment.scApiHost}:${environment.scApiPort}/api/SantaCruz/SegmentBadPricingZone`)
      .pipe(
        map((r: any) => ({

            data: r,

            isLoading: false,
            isLoaded: true,
            isError: false,
            errorMessage: ''
        }))
      );

    this.viewState$ = merge(initial, loader);

  }

}
